import Reveal from "@/components/7fcc/Reveal";
import CTAButton from "@/components/7fcc/CTAButton";
import { HOME } from "@/data/homeContent";

export default function HomeFinal() {
  const f = HOME.final;
  return (
    <section className="relative overflow-hidden bg-ink-950 px-6 py-20 text-center md:py-28" data-testid="home-final">
      <div
        aria-hidden="true"
        className="absolute inset-x-0 bottom-[-30%] mx-auto h-[380px] w-[860px] max-w-full rounded-full bg-[radial-gradient(circle,rgba(61,126,255,0.1),transparent_65%)] blur-3xl"
      />
      <div className="relative mx-auto flex max-w-3xl flex-col items-center">
        <Reveal>
          <p className="flex items-center justify-center gap-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-brand-light" data-testid="home-final-eyebrow">
            <span className="h-px w-6 bg-brand/60" aria-hidden="true" />
            {f.eyebrow}
            <span className="h-px w-6 bg-brand/60" aria-hidden="true" />
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2
            className="mt-5 font-display text-3xl font-semibold uppercase leading-[1.08] text-chrome md:text-5xl"
            data-testid="home-final-heading"
          >
            {f.headline}
          </h2>
        </Reveal>
        <Reveal delay={0.14}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-fg-muted md:text-lg" data-testid="home-final-body">
            {f.body}
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
            <CTAButton label={f.cta1.label} href={f.cta1.href} testId="home-final-apply" />
            <CTAButton
              label={f.cta2.label}
              targetId={f.cta2.anchor}
              variant="chrome"
              testId="home-final-assessment"
            />
          </div>
        </Reveal>
        <Reveal delay={0.26}>
          <p className="mt-12 border-t border-line pt-8 text-sm text-silver-mid md:text-base" data-testid="home-final-closing">
            {f.closing}
          </p>
        </Reveal>
      </div>
    </section>
  );
}